<template>
  <div>
    <PageAllow controller="TakeMaterialTemplates" action="viewByTemplate" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <v-text-field
                v-model="materialNameSearch"
                :label="$t('TakeTemplates.DetailFields.material_name')"
                clearable
              ></v-text-field>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="getTemplatesFromAPI()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="materialNameSearch = ''"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                v-if="savable"
                small
                dark
                color="primary"
                @click.stop="selectMaterialsDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
             </v-btn>
             <v-btn
              small
              v-if="!savable"
              color="primary"
              @click="mode = 'edit'"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
              {{ $t("CRUD.edit") }}
            </v-btn>
            <v-btn
              outlined
              small
              v-if="savable"
              color="secondary"
              @click="mode = 'view'"
              class="ms-1 elevation-1"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.abandon") }}
            </v-btn>
            <v-btn
              small
              v-if="savable"
              color="success"
              @click="saveTemplateMaterials()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{ $t("CRUD.save") }}
            </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="templateDetails"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          > <template v-slot:body.prepend>
            <tr v-if="savable" class="d-none d-sm-table-row">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    take_template_details.find((detail) => detail.valid != validAll)
                      ? true
                      : false
                  "
                  v-model="validAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                     {{ $t("TakeTemplates.DetailFields.valid_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
            </tr>
           <tr v-if="savable" class="d-table-row d-sm-none">
             <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("TakeTemplates.DetailFields.usable") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      take_template_details.find(
                        (detail) => detail.valid != validAll
                      )
                        ? true
                        : false
                    "
                    v-model="validAll"
                    :label="$t('TakeTemplates.DetailFields.valid_all')"
                  ></v-checkbox>
                </div>
              </td>
           </tr>
          </template>
          <template v-slot:item.valid="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.valid"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.valid
                          ? "TakeTemplates.DetailFields.usable_on"
                          : "TakeTemplates.DetailFields.usable_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.show_categories="{ item }">
              <v-tooltip
                right
                v-if="item.show_categories && item.show_categories.length > 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{
                      item.show_categories[0].parent_show_category
                        ? item.show_categories[0].parent_show_category.name + " : "
                        : ""
                    }}
                    {{ item.show_categories[0].name }}
                    {{ item.show_categories.length > 1 ? "..." : "" }}
                  </span>
                </template>
                <span
                  v-for="(show_category, index) in item.show_categories"
                  :key="show_category.id"
                  class="d-inline"
                >
                  {{
                    show_category.parent_show_category
                      ? show_category.parent_show_category.name + " : "
                      : ""
                  }}
                  {{
                    show_category.name +
                    (index == item.show_categories.length - 1 ? "" : ",")
                  }}
                </span>
              </v-tooltip>
           </template>
           <template v-slot:item.material_name="{ item }">
             {{item.material_name}}
             <br />
              <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                <span v-if="item && item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item ? item.standard_name : '' }}
                </span>
              </span>
           </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <SelectTemplateMaterials
      v-model="selectMaterialsDialog"
      :templateDetails="take_template_details"
      @confirm="
        changedDetails = $event;
      "
      showCategories
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
// import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import TakeMaterialTemplates from "@/api/take_material_templates";
import SelectTemplateMaterials from "./plugins/SelectTemplateMaterials";


export default {
  components: {
    PageAllow,
    Breadcrumbs,
    // Template,
    SelectTemplateMaterials
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    items() {
      return [
          {
            text: i18n.t("Nav.home"),
            disabled: false,
            href: "/home",
          },
          {
            text: i18n.t("Nav.stockManagement"),
            disabled: false,
            href: "/current-stocks",
          },
          {
            text: i18n.t("Nav.stockTakes"),
            disabled: false,
            href: "/stock-takes",
          },
          {
            text: i18n.t("Nav.takeTemplates"),
            disabled: false,
            href: "/stock-takes/take-templates",
          },
          {
            text: i18n.t("Nav.materialTemplatePriceSet"),
            disabled: true,
            href: "",
          },
          {
            text:
              this.template && this.template.template_name
                ? this.template.template_name
                : i18n.t("Nav.materialTemplateDetail"),
            disabled: false,
            accent: true,
          },
      ]
    },
     
    headers() { 
      var headers =
        [ 
          {
            text: i18n.t("TakeTemplates.DetailFields.material_category"),
            align: "start",
            sortable: true,
            filterable: true,
            value: "category_name",
          },
          {
            text: i18n.t("TakeTemplates.DetailFields.show_categories"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "show_categories",
          },   
          {
            text: i18n.t("TakeTemplates.DetailFields.material_code"),
            align: "center",
            sortable: false,
            filterable: false,
            value: "material_code",
          }, 
          {
            text: i18n.t("TakeTemplates.DetailFields.material_name"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "material_name",
          },
           {
            text: i18n.t("TakeTemplates.DetailFields.unit"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "unit",
          }, 
        ]
      
      if (this.savable) { 
        headers.push(
          {
            text: i18n.t("TakeTemplates.DetailFields.usable"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "valid",
          }
        )
      }
      
      return  headers
    },
     templateDetails() {
      return this.take_template_details.filter(
        (item) =>
          (!this.materialNameSearch || item.material_name.indexOf(this.materialNameSearch) >= 0)
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getTemplatesFromAPI();
    this.mode = this.$route.params.mode;
    if (this.mode) this.$router.replace("/stock-takes/take-templates/" + this.$route.params.id);
  },

  data: () => ({
    materialNameSearch: "",
    templates: [],
    take_template_details: [],
    mode: "",
    validAll: 1,
    selectMaterialsDialog: false,
    changedDetails: [],
     template: {},
  }),

  methods: {
    getTemplatesFromAPI() {
      TakeMaterialTemplates.fetch(this.$route.params.id, {limit: this.$consts.limitAll}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.take_template_details = response.data.take_template_details.map(
              (item) => {
                item.valid = item.status;
                return item;
              })
             this.template = response.data.template
          }
        }.bind(this)
      );
    },
    saveTemplateMaterials() {
      console.log(this.take_template_details)
      this.$store.dispatch("fullscreenLoading");
      var data = this.take_template_details
        .filter(
          (detail) =>
            detail.valid || // 保存生效的商品
            detail.status != detail.valid // 以及生效状态改变的商品
        )
        .map(
          function (detail) {
            let detailData = {
              id: detail.id,
              material_id: detail.material_id,
              status: detail.valid,
              template_id:this.$route.params.id
            };
            return detailData;
          }.bind(this)
        );
      TakeMaterialTemplates.batchSave(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.mode = "view";
              this.getTemplatesFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
  },
  watch: {
     mode: {
        handler() {
          if (this.isView) {
            this.validAll = 1;
          }
        },
    },
    validAll: {
      handler() {
        this.take_template_details = this.take_template_details.map(
          function (detail) {
            detail.valid = this.validAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    changedDetails: {
      handler() {
        this.take_template_details.forEach((d) => { 
          //未保存的新增商品在弹窗取消生效，同步到模板商品一览
          if (this.changedDetails.findIndex((item) => item.material_id == d.material_id) == -1) { 
               d.valid = 0
          }
        })
        this.changedDetails.forEach((detail) => { 
          var item = this.take_template_details.find((item) => item.material_id == detail.material_id)
          if (item) {
            item.valid = detail.valid
          } else { 
            this.take_template_details.push(detail)
          }
        })
      }
    }
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>